"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var OutlineIcons = require("../Icons/LineIcons");
var MiscIcons = require("../Icons/Misc");
var SolidIcons = require("../Icons/SolidIcons");
var GSIcons = require("../Icons/Misc/GSIcons");
var GSClaimIcons = require("../Icons/Misc/GSIcons/Claim");
var sizes = {
    xs: 'squid-h-component-icon-size-xs squid-w-component-icon-size-xs',
    sm: 'squid-h-component-icon-size-sm squid-w-component-icon-size-sm',
    md: 'squid-h-component-icon-size-base squid-w-component-icon-size-base',
    lg: 'squid-h-component-icon-size-lg squid-w-component-icon-size-lg',
    xl: 'squid-h-component-icon-size-xl squid-w-component-icon-size-xl',
    '2xl': 'squid-h-component-icon-size-2xl squid-w-component-icon-size-2xl',
};
var getIconByName = function (variant, icon) {
    switch (variant) {
        case 'outline':
            return OutlineIcons[icon];
        case 'solid':
            return SolidIcons[icon];
        case 'misc':
            return MiscIcons[icon];
        case 'gs':
            return GSIcons[icon];
        case 'gs-claim':
            return GSClaimIcons[icon];
    }
};
var Icon = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'outline' : _b, icon = _a.icon, _c = _a.size, size = _c === void 0 ? 'md' : _c, fill = _a.fill, className = _a.className, highlight = _a.highlight, highlightClassName = _a.highlightClassName, dataTestId = _a.dataTestId, branding = _a.branding;
    var _d = (0, theme_1.useIconColors)({
        highlight: !!fill,
        branding: branding,
    }), colors = _d.colors, highlightColors = _d.highlightColors;
    var fillClass = fill ? colors === null || colors === void 0 ? void 0 : colors[fill] : undefined;
    var bgClass = fill ? highlightColors === null || highlightColors === void 0 ? void 0 : highlightColors[fill] : undefined;
    var sizeClass = sizes[size];
    var svg;
    if (typeof icon === 'string') {
        var SvgIcon = getIconByName(variant, icon);
        if (!SvgIcon) {
            return (0, jsx_runtime_1.jsxs)("span", { children: ["??", icon, "??"] });
        }
        svg = ((0, jsx_runtime_1.jsx)(SvgIcon, { className: (0, classnames_1.default)('squid-pointer-events-none', fillClass, sizeClass, className), "aria-hidden": "true", "data-testid": dataTestId }));
    }
    else {
        svg = icon;
    }
    if (highlight) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex', 'squid-justify-center', 'squid-item-center', 'squid-p-2.5', 'squid-w-max', {
                'squid-rounded-core-border-radius-xs': highlight === 'rounded',
                'squid-rounded-core-border-radius-max': highlight === 'circle',
            }, bgClass, highlightClassName) }, { children: svg })));
    }
    return svg;
};
exports.Icon = Icon;
